import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-pill border px-2.5 py-0.5 text-[10.5px] font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-cp-grad text-white shadow-cp-accent",
        secondary:
          "border-cp-line bg-cp-inset text-cp-muted",
        destructive:
          "border-transparent bg-[color-mix(in_srgb,var(--crit)_18%,transparent)] text-cp-crit",
        outline: "text-cp-fg border-cp-line",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
